import { DataBean } from "../DataBean";

export class GoodsSupport extends DataBean {



    public async deleteGoodsSupport(idGoodsSupport: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteGoodsSupport_Number", [idGoodsSupport]);
    }

    public async getGoodsSupportCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getGoodsSupportCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}